var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"fab":"","depressed":"","color":"white"}},[_c('div',{attrs:{"top":"","left":""}},[[_c('v-badge',{attrs:{"right":"","color":'red',"content":2,"overlap":""}},[_c('v-icon',[_vm._v(" mdi-bell-outline ")])],1)]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }